module.exports = __webpack_public_path__ + "img/zhengke.58d9e273.jpg";